module.exports = "/_next/static/images/5f83f535c7cd85fc4b308468a0b336ad-roxinho-scene-card-with-phone-md@3x.jpg.webp";